import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, ScrollToTop } from "../../../components";
import { Box, Button, Divider, Paper, Snackbar, Alert, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { Col, Row, Form } from "react-bootstrap";

const TambahLaporanPolisi = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const [tglLaporanPolisi, setTglLaporanPolisi] = useState(new Date().toISOString().slice(0, 10));
  const [noJual, setNoJual] = useState("");
  const [keterangan, setKeterangan] = useState("");
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const textRight = { textAlign: screenSize >= 650 ? "right" : undefined };

  const saveData = async (event) => {
    event.preventDefault();
    if (!tglLaporanPolisi || !noJual.trim() || !keterangan.trim()) {
      setValidated(true);
      setError("Tanggal, No. Jual, dan keterangan wajib diisi.");
      return;
    }
    const now = new Date();
    setLoading(true);
    try {
      await axios.post(tempUrl + "/saveLaporanPolisi", {
        tglLaporanPolisi,
        noJual: noJual.trim(),
        keterangan: keterangan.trim(),
        tglInput: now.getDate() + "-" + (now.getMonth() + 1) + "-" + now.getFullYear(),
        jamInput: now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds(),
        userInput: user.username,
        kodeCabang: user.cabang ? user.cabang._id : undefined,
        id: user._id,
        token: user.token,
      });
      navigate("/laporanPolisi");
    } catch (requestError) {
      if (requestError.response && requestError.response.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        setError(requestError.response && requestError.response.data && requestError.response.data.message || "Gagal menyimpan data.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;
  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>Tambah Laporan Polisi</Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={saveData}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Tanggal LP :</Form.Label>
                <Col sm="8"><Form.Control required type="date" value={tglLaporanPolisi} onChange={(event) => setTglLaporanPolisi(event.target.value)} /></Col>
              </Form.Group></Col></Row>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>No. Jual :</Form.Label>
                <Col sm="8"><Form.Control required value={noJual} onChange={(event) => setNoJual(event.target.value)} /></Col>
              </Form.Group></Col></Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row><Col><Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4" style={textRight}>Keterangan :</Form.Label>
                <Col sm="8"><Form.Control required as="textarea" rows={4} value={keterangan} onChange={(event) => setKeterangan(event.target.value)} /></Col>
              </Form.Group></Col></Row>
            </Box>
          </Box>
          <Box sx={buttonContainer}>
            <Button variant="outlined" color="secondary" onClick={() => navigate("/laporanPolisi")} sx={{ marginRight: 2 }}>{"< Kembali"}</Button>
            <Button variant="contained" startIcon={<SaveIcon />} type="submit">Simpan</Button>
          </Box>
        </Form>
      </Paper>
      <Snackbar open={Boolean(error)} autoHideDuration={5000} onClose={() => setError("")}><Alert severity="error">{error}</Alert></Snackbar>
    </Box>
  );
};

export default TambahLaporanPolisi;

const subTitleText = { fontWeight: "900" };
const dividerStyle = { pt: 4 };
const contentContainer = { mt: 4, p: 4 };
const showDataContainer = { display: "flex", flexDirection: { xs: "column", sm: "row" } };
const showDataWrapper = { display: "flex", flex: 1, flexDirection: "column", maxWidth: { md: "40vw" } };
const secondWrapper = { marginLeft: { sm: 4 }, marginTop: { sm: 0, xs: 4 } };
const buttonContainer = { mt: 3, display: "flex", justifyContent: "center" };
